import capitalize from "lodash/capitalize";
import { t } from "@/i18n-js/instance";
import { DefaultEditorFieldsList } from "./DefaultEditorFieldsList";
import { EditorCollapsable } from "./EditorCollapsable";
import type { TabGroups, TabOnlyGroups } from "./useCategorizedBlockProps";

export interface DefaultEditorCategoryContentProps {
  category: string;
  nestedGroups: TabGroups;
  tabOnlyGroups: TabOnlyGroups;
}

export const DefaultEditorCategoryContent = ({
  category,
  nestedGroups,
  tabOnlyGroups,
}: DefaultEditorCategoryContentProps) => (
  <>
    {nestedGroups[category] &&
      Object.entries(nestedGroups[category]).map(
        ([collapsibleCategory, fields]) => (
          <EditorCollapsable
            key={collapsibleCategory}
            title={t(["builder_ui.block_props_category", collapsibleCategory], {
              defaultValue: capitalize(collapsibleCategory),
            })}
            defaultOpen
          >
            <DefaultEditorFieldsList fields={fields} />
          </EditorCollapsable>
        ),
      )}
    {tabOnlyGroups[category] && (
      <DefaultEditorFieldsList fields={tabOnlyGroups[category]} />
    )}
  </>
);
